import { render } from "./MessageList.vue?vue&type=template&id=273dff86&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=273dff86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-273dff86"

export default script